module.exports = __webpack_public_path__ + "assets/img/btn-detail-4e8946b8.png";